'use strict';

import $ from 'jquery';
import 'inputmask/dist/inputmask/jquery.inputmask';
import 'inputmask/dist/inputmask/inputmask.numeric.extensions';
import {setupInputMask} from '../components/form.inputmask.js'

let InputMask = require('inputmask/dist/inputmask/inputmask');

(function () {
    let $form = $("form[name='web_calculation_entryForm']");

    if ($form.length) {
        setupInputMask();
    }

    const radiosUnits = $("[name='switch-units']");

    function switchUnits() {
        let radioChecked = $("[name='switch-units']:checked").val();
        let radioNotChecked = $("[name='switch-units']:not(:checked)").val();

        let divShow = $(`[name='${radioChecked}']`);
        let divHide = $(`[name='${radioNotChecked}']`);

        divShow.css('display', 'block');
        divHide.css('display', 'none');
    }

    radiosUnits.on('change', switchUnits);

})();




// WEBPACK FOOTER //
// ./app/Resources/assets/js/scripts/calculator.js